import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const ActionValidIconMedium: React.FC<IconProps> = (props) => (
  <IconWrapper {...props}>
    <path d="M19.07 3C20.13 3 21 3.86 21 4.93v14.15c0 1.06-.86 1.93-1.93 1.93H4.93c-1.06 0-1.93-.86-1.93-1.93V4.93C3 3.87 3.86 3 4.93 3h14.15m0-1H4.93C3.32 2 2 3.31 2 4.93v14.15c0 1.61 1.31 2.93 2.93 2.93h14.15c1.61 0 2.93-1.31 2.93-2.93V4.93C22.01 3.32 20.7 2 19.08 2Z" />
    <path d="m9.86 17.03-4.71-4.72.71-.7 4 4 8.28-8.28.71.71-8.99 8.99Z" />
  </IconWrapper>
)

export default ActionValidIconMedium
